import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { createImageUrlBuilder } from '@sanity/image-url';
import { client } from '@/sanity/client';
const builder = createImageUrlBuilder(client);
function urlFor(source: any) {
  return builder.image(source);
}
interface TeamMember {
  name?: string;
  slug?: {
    current: string;
  };
  title?: string;
  bio?: string;
  image?: any;
  email?: string;
  phone?: string;
  mobile?: string;
  office?: string;
  address?: string;
}
interface TeamSectionProps {
  title?: string;
  imagePosition?: 'left' | 'right';
  teamMember?: TeamMember;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}
export default function TeamSection(t0) {
  const $ = _c(27);
  const {
    title: t1,
    imagePosition: t2,
    teamMember,
    primaryButtonText: t3,
    primaryButtonLink: t4,
    secondaryButtonText: t5,
    secondaryButtonLink: t6
  } = t0;
  const title = t1 === undefined ? "Our Team" : t1;
  const imagePosition = t2 === undefined ? "left" : t2;
  t3 === undefined ? "LEARN MORE" : t3;
  t4 === undefined ? "/about/our-team" : t4;
  const secondaryButtonText = t5 === undefined ? "SCHEDULE A CALL" : t5;
  const secondaryButtonLink = t6 === undefined ? "/contact-us" : t6;
  if (!teamMember) {
    return null;
  }
  const isImageLeft = imagePosition === "left";
  const teamMemberUrl = teamMember.slug?.current ? `/real-estate-agent/${teamMember.slug.current}` : null;
  const t7 = `max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-start gap-6 sm:gap-8 lg:gap-12 ${isImageLeft ? "" : "md:flex-row-reverse"}`;
  let t8;
  if ($[0] !== teamMember.image || $[1] !== teamMember.name || $[2] !== teamMemberUrl) {
    t8 = teamMember.image && (teamMemberUrl ? <Link href={teamMemberUrl}><Image src={urlFor(teamMember.image).width(1000).url()} alt={teamMember.name || "Team member"} width={1000} height={1000} className="w-full h-auto" sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 55vw" loading="lazy" itemProp="image" /></Link> : <Image src={urlFor(teamMember.image).width(1000).url()} alt={teamMember.name || "Team member"} width={1000} height={1000} className="w-full h-auto" sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 55vw" loading="lazy" itemProp="image" />);
    $[0] = teamMember.image;
    $[1] = teamMember.name;
    $[2] = teamMemberUrl;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== t8) {
    t9 = <div className="w-full md:w-1/2 lg:w-[55%] flex-shrink-0">{t8}</div>;
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== title) {
    t10 = <h2 className="!mt-0 !pt-0 mb-3 sm:mb-4 lg:mb-6 text-[var(--color-sothebys-blue)] dark:text-white">{title}</h2>;
    $[6] = title;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== teamMember.name) {
    t11 = teamMember.name && <span className="hidden" itemProp="name">{teamMember.name}</span>;
    $[8] = teamMember.name;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== teamMember.title) {
    t12 = teamMember.title && <span className="hidden" itemProp="jobTitle">{teamMember.title}</span>;
    $[10] = teamMember.title;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== teamMember.bio) {
    t13 = teamMember.bio && <p className="mb-6 sm:mb-8 lg:mb-10 text-sm sm:text-base md:text-base lg:text-lg text-[#4a4a4a] dark:text-gray-300 leading-relaxed md:leading-relaxed lg:leading-loose" itemProp="description">{teamMember.bio}</p>;
    $[12] = teamMember.bio;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== secondaryButtonLink || $[15] !== secondaryButtonText) {
    t14 = secondaryButtonText && secondaryButtonLink && <Link href={secondaryButtonLink} className="sir-btn"><span>{secondaryButtonText}</span><span className="sir-arrow" /></Link>;
    $[14] = secondaryButtonLink;
    $[15] = secondaryButtonText;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t12 || $[20] !== t13 || $[21] !== t14) {
    t15 = <div className="w-full md:w-1/2 lg:w-[45%] md:pl-6 lg:pl-8 xl:pl-16">{t10}{t11}{t12}{t13}{t14}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t15 || $[24] !== t7 || $[25] !== t9) {
    t16 = <section className="w-full py-12 md:py-16 lg:py-20" itemScope={true} itemType="https://schema.org/Person"><div className={t7}>{t9}{t15}</div></section>;
    $[23] = t15;
    $[24] = t7;
    $[25] = t9;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}